import { render } from "./WebphoneMenu.vue?vue&type=template&id=1ce7b244&scoped=true"
import script from "./WebphoneMenu.vue?vue&type=script&lang=js"
export * from "./WebphoneMenu.vue?vue&type=script&lang=js"

import "./WebphoneMenu.vue?vue&type=style&index=0&id=1ce7b244&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce7b244"]])

export default __exports__